import { render } from "./AddAreaModal.vue?vue&type=template&id=2c06a3fc&lang=pug"
import script from "./AddAreaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAreaModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__